import axios from 'axios'

const Accounts = {
  async getOrganizations (params = {}) {
    return axios.get('organizations', { params })
  }
}

const Locations = {
  async getRegions (params = {}) {
    return axios.get('regions', { params })
  },

  async getProvinces (params = {}) {
    return axios.get('provinces', { params })
  },

  async getMunicipalities (params = {}) {
    return axios.get('municipalities', { params })
  },

  async getBarangays (params = {}) {
    return axios.get('barangays', { params })
  }
}

const SharedListService = {
  async getRoles (params = {}) {
    return axios.get('shared/list/roles', { params })
  },

  async getDiagnostics (params = {}) {
    return axios.get('shared/list/diagnostics', { params })
  },

  async getPackages (params = {}) {
    return axios.get('shared/list/packages', { params })
  },

  async getCardTypes (params = {}) {
    return axios.get('shared/list/card-types', { params })
  },

  async getSystemOptions (params = {}) {
    return axios.get('shared/list/system-options', { params })
  }
}

export default Object.assign(SharedListService, Accounts, Locations)
